module.exports = __webpack_public_path__ + "static/img/hr_member_header_bg.a10396d0.png";